(function () {
  function initGiftCardRecipientForms() {
    document.querySelectorAll('[data-product-form]').forEach(function (form) {
      var emailInput = form.querySelector('[name="properties[Recipient email]"]');
      if (!emailInput || form.dataset.giftCardRecipientInit) {
        return;
      }

      form.dataset.giftCardRecipientInit = 'true';
      form.setAttribute('data-gift-card-recipient', '');

      var addToCartButton = form.querySelector('.add-to-cart');
      if (!addToCartButton) {
        return;
      }

      addToCartButton.addEventListener(
        'click',
        function (event) {
          if (!emailInput.reportValidity()) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        },
        true
      );
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGiftCardRecipientForms);
  } else {
    initGiftCardRecipientForms();
  }
})();
